import { ApplicationBracesIcon } from './ApplicationBracesIcon';

/**
 * author: Michael Irigoyen
 * id 6453ED46-EC58-4FE8-94C3-1AC170E42152
 * name application-braces
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-braces.svg
 * tags
 * - Developer / Languages 
 */
export const IframeBracesIcon = ApplicationBracesIcon;
export default IframeBracesIcon